module.exports = __webpack_public_path__ + "static/media/Quest20_Lock@3x.7f4be0d2.png";